import Navbar from "./LandingNavBar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";


function Layout() {
  return (
    <>
      <Navbar />

      <div className="pt-28">
        <Outlet />
      </div>

      <Footer />
    </>
  );
}

export default Layout;